import { axios, HOST, config } from "./settiing";

export default {
  /** cancel api **/
  getCanceledReservationPeriod(start, end, params) {
    let query = "";
    Object.keys(params).forEach((k) => (query = query + `${k}=${params[k]}&`));
    return axios.get(
      `${HOST}/manage/web/canceled-reservation/${start}/${end}?${query}`,
      config
    );
  },
  getCanceledReservation(id) {
    return axios.get(`${HOST}/manage/canceledReservation/${id}`, config);
  },
  addCanceledReservation(data) {
    return axios.post(`${HOST}/manage/canceledReservation`, data, config);
  },

  addCanceledReservationWithoutCusomter(data) {
    return axios.post(`${HOST}/manage/cancel/reservation`, data, config);
  },

  createCanceledReservation(data) {
    return axios.post(`${HOST}/manage/cancel/reservation`, data, config);
  },
  updateCanceledReservation(data) {
    return axios.put(`${HOST}/manage/canceledReservation/state`, data, config);
  },

  updatedPaymentInfo(data) {
    return axios.post(
      `${HOST}/manage/canceledReservation/payment`,
      data,
      config
    );
  },
};
